// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__oCZsS","display":"style_display__3UllG","isAverage":"style_isAverage__1_i-1"};